<template>
  <div id="app" :class="[navOpen ? 'nav-open' : '', schedOpen ? 'sched-open' : '', quotesOpen ? 'quotes-open' : '']">
	  <Header/> 
	  <Navigation/>
	  <Livestream/>
    
    <div class="mh">
        <router-view/>
    </div>
  
    <Footer />
    <div class="protect" @click="protectClick"></div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Navigation from './components/Navigation.vue'
import Livestream from './components/Livestream.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
	  Header,
	  Navigation,
	  Livestream,
	  Footer
  },
  data() {
	  return {
	   
	  }
  },
  metaInfo: {
    titleTemplate: (titleChunk) => {
		  return titleChunk ? `${titleChunk} - Performa` : 'Performa';
		}
  },
  computed: {
    navOpen () {
      return this.$store.state.navOpen
    },
    schedOpen () {
	    return this.$store.state.schedOpen
    },
    quotesOpen(){
      return this.$store.state.quotesOpen
    }
  },
  methods: {
    protectClick () {
      this.$store.dispatch('toggleSched')
    }
  },
  created () {
	  window.prerenderReady = false;
  },
  mounted: function () {
	  this.$nextTick(function () {
	    window.prerenderReady = true
	  })
	}
}
</script>

<style scoped>
@import "./assets/css/prismic-edit-button.css";
@import "./assets/css/performa.css";

.fade-enter{
        opacity: 0;
    }
    .fade-enter-active{
        transition: opacity 250ms;
    }
    .fade-leave{
        /* opacity: 1; */
    }
    .fade-leave-active{
        transition: opacity 250ms;
        opacity: 0;
    }
</style>
